import RequestAbstract from "../abstract";

export default class PublicAggregations extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-aggregations";
    }

}
